import { render, staticRenderFns } from "./ImageTextNavSelector.vue?vue&type=template&id=921bddae&scoped=true"
import script from "./ImageTextNavSelector.vue?vue&type=script&lang=js"
export * from "./ImageTextNavSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921bddae",
  null
  
)

export default component.exports